<template>
  <div >
    <!-- 顶部工具条 -->
    <el-col :span="24">
      <el-form :inline="true">
        <el-form-item label='关键字:'>
          <el-input placeholder="请输入"  v-model="filters.keyWord" clearable
          >
          </el-input>
        </el-form-item>
          <el-form-item label="是否启用:">
          <el-select v-model="filters.isEnable" clearable placeholder="请选择">
            <el-option 
              v-for="item in isEnableOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
        </el-form-item>
      </el-form>
    </el-col>
    <!-- 表格 -->
    <el-table 
      v-loading="loading" 
      :data="tableData" 
      style="width:100%" 
      border 
      highlight-current-row 
      @current-change="handlerowChange"
    >
     <el-table-column  label="考试名称" width="200" align="center" prop="ExamName"></el-table-column>
      <el-table-column  label="创建时间" width="" align="center" prop="CreateTime"></el-table-column>
      <el-table-column  label="截止时间" width="" align="center" prop="CreateTime" :formatter="formatCreateTime">
            <template slot-scope="scope">
                <span>{{scope.row.ExamBeginTime}}-{{scope.row.ExamEndTime}}</span>

            </template>
      </el-table-column>
      <el-table-column label="启用标识" width="100" align="center" prop="IsEnable">
        <template slot-scope="scope">
          <el-tag
              :type="scope.row.IsEnable == true ? 'success' : 'danger'" disable-transitions>{{scope.row.IsEnable == true ? "启用":"禁用"}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="二维码" width="200" align="center">
        <template slot-scope="scope">
          <span style="color: #409EFF;cursor:pointer;" @click="handlePreview(scope.row)">预览</span>
          <span style="color: #409EFF;cursor:pointer;margin-left:20px;" @click="handleDownload(scope.row)">下载</span>
        </template> 
      </el-table-column>
      <el-table-column label="关联人数" width="200" align="center">
        <template slot-scope="scope">
          <span style="color: #409EFF;cursor:pointer;" @click="openRelatedPopulationDialog(scope.row)">{{scope.row.StaffCount}}</span>
        </template> 
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-col :span="24" class="pageBarContainer">
      <el-pagination
        small
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        :current-page="pages.pageIndex"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange"
        class="pageBarContainer"
        >
      </el-pagination>
    </el-col>    
    <!-- 新增/编辑 -->
    <el-dialog
      :title="isAdd?'新增':'编辑'"
      :visible.sync="FormVisible"
      :close-on-click-modal="false"
      width="50%"
      >
        <el-form :model="Form" label-width="110px" label-position="center" ref="FormRef" :rules="FormRules">
            <el-form-item label="考试名称:" prop="examName" with="100">
                <el-input  placeholder="请输入考试名称" v-model="Form.examName"></el-input>
            </el-form-item>
            <el-form-item label="考试时间:" prop="examTime" >
                <el-date-picker
                    v-model="Form.examTime"
                    type="datetimerange"
                    format="yyyy 年 MM 月 dd 日 HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width:500px"
                >
                </el-date-picker>
             </el-form-item>
            <el-form-item label="启用标识:" prop="isEnable">
                <el-radio-group v-model="Form.isEnable">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="FormVisible = false">取 消</el-button>
            <el-button type="primary" @click.native="FormSubmit" :loading="loading">保 存</el-button>
        </span>
    </el-dialog>

     <!--新增预览弹窗 -->
    <el-dialog
      title="二维码预览"
      :visible.sync="previewDialogVisible"
      width="60%"
      top="5vh"
      custom-class="pdf-preview-dialog"
      @close="closePreview"
    >
      <div v-if="previewDialogVisible" style="display:flex;justify-content:center;">
           <QRCode 
                v-if="previewUrl"
                :value="previewUrl"
                :size="200"
                level="H"
              />
       
      </div>
    </el-dialog>
    <!--人群名单 -->
     <el-dialog
      title="人群名单"
      :visible.sync="RelatedPopulationDialog"
      width="60%"
      height="300px"
      top="5vh"
      
    >
      <el-table 
        v-loading="loading" 
        :data="tableData2" 
        style="width:100%" 
        border 
        highlight-current-row
      >
       <el-table-column  label="姓名" width="200" align="center" prop="Name"></el-table-column>
        <el-table-column  label="手机号" width="" align="center" prop="PhoneNumber"></el-table-column>
        <el-table-column  label="工作单位" width="" align="center" prop="UnitName" >    
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      
        <el-pagination
          small
          :page-sizes="pages2.pageArr"
          :page-size="pages2.pageSize"
          :current-page="pages2.pageIndex"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pages2.dataCount"
          @size-change="handleSizeChange2" 
          @current-change="handleCurrentChange2"
          class="pageBarContainer"
          >
        </el-pagination>

    </el-dialog>
     <el-dialog
      title="关联人群"
      :visible.sync="AddPopulationDialog"
      width="60%"
      height="300px"
      top="5vh"
      
    >
      <el-form :model="Form2" label-width="110px" label-position="center" ref="FormRef2" :rules="FormRules2">
        <el-form-item label="关联方式:">
              <el-radio-group v-model="Form2.relateMethods">
              <el-radio :label="0">按人群筛选</el-radio>
              <el-radio :label="1">输入手机号</el-radio>
              </el-radio-group>
        </el-form-item>
         <el-form-item label="选择人群:"  v-if="Form2.relateMethods==0"  prop="socialGroupId">
          
                    <el-select v-model="Form2.socialGroupId" >
                        <el-option
                            v-for="item in GroupListOption"
                            :key="item.ID"
                            :label="item.Name"
                            :value="item.ID"
                        >
                        </el-option>
                    </el-select>
        </el-form-item>
        <el-form-item label="输入手机号:"  v-if="Form2.relateMethods==1" prop="phoneNumber">
            <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请输入手机号"
                        v-model="Form2.phoneNumber"
                        clearable
                        maxlength="3000"
                    />
        </el-form-item>
      </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="AddPopulationDialog = false">取 消</el-button>
            <el-button type="primary" @click.native="AddPopulationSubmit" :loading="loading">保 存</el-button>
        </span>
      


  
     </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import QRCode from 'qrcode.vue';
  import QRCode2 from 'qrcode'; 
// 数据请求
import {getExamProjectInfoQRListPage,deleteExamProjectInfoQR,addExamProjectInfoQR,updateExamProjectInfoQR,uploadObsDocumentFile,getExamProjectInfoQRStaffList,getSocialGroupList,addExamProjectInfoQRStaff} from '@/api/api'
export default {
  components:{Toolbar,QRCode},
  data(){
    return {
      isAdd:false,
      //是否启用
      isEnableOption:[
        {
          value:'0',
          label:'禁用'
        },
        {
          value:'1',
          label:'启用'
        }
      ],
      // 资料类型
      TypeOption:[
        {
          value:'0',
          label:'ppt'
        },
        {
          value:'1',
          label:'txt'
        },
        {
          value:'2',
          label:'pdf'
        },        
      ],
      // 筛选
      filters:{
        keyWord:null,
        examTime:null,
        isEnable:null
      },
      // 增删改查等按钮
      buttonList: [],
      // 表格中的数据
      tableData:[],
      tableData2:[],
      // 分页
      pages:{
        pageArr:[10,20,30,40],
        pageSize:20,
        pageIndex:1,
        dataCount:1,
      },
       // 分页
      pages2:{
        pageArr:[10,20,30,40],
        pageSize:20,
        pageIndex:1,
        dataCount:1,
      },
      // 加载控制
      loading:false,
      // 新增数据
      Form:{
        examName:'',
        examTime:'',
        isEnable:1,
      },
      FormRules:{
        examName:[{required:true,message:'请输入资料名称',trigger:'blur'}],
        examTime:[{required:true,message:'请选择考试时间',trigger:'blur'}],
        isEnable:[{required:true,message:'请选择启用状态',trigger:'change'}],
      },
      Form2:{
        relateMethods:0,
        socialGroupId:"",
        phoneNumber:""
        
      },
       FormRules2:{
        socialGroupId:[{required:true,message:'请选择人群',trigger:'blur'}],
        phoneNumber:[{required:true,message:'请输入手机号',trigger:'blur'}],
      },
      currentRow:null,
      FormVisible:false,
      fileList:[],
      uploadObsDocumentFile:null,
      previewDialogVisible:false,
      previewUrl:'',
      RelatedPopulationDialog:false,
      AddPopulationDialog:false,
      GroupListOption:[]
    }
  },
  methods:{
    getList(){
      this.loading = true
      var params = {
        keyWord:this.filters.keyWord,
        isEnable:this.filters.isEnable,
        pageIndex:this.pages.pageIndex,
        pageSize:this.pages.pageSize,
       
      }
      getExamProjectInfoQRListPage(params).then(res => {     
        this.tableData = res.data.Response.Data
        this.pages.dataCount = res.data.Response.DataCount
        this.loading = false
      })
    },
    // 数据条数改变
    handleSizeChange(newSize){
      this.pages.pageSize = newSize   
      this.getList()
    },
    // 当前页改变
    handleCurrentChange(newPage){
      this.pages.pageIndex = newPage   
      this.getList()
    },
     // 数据条数改变
    handleSizeChange2(newSize){
      this.pages2.pageSize = newSize   
      this.getExamProjectInfoQRStaffListFun()
    },
    // 当前页改变
    handleCurrentChange2(newPage){
      this.pages2.pageIndex = newPage   
      this.getExamProjectInfoQRStaffListFun()
    },
    // 表格当前行改变事件
    handlerowChange(row){
      this.currentRow = row
    },
    // 查询
    handleSearch() {  
      this.pages.pageIndex = 1
      this.getList()
    },
    // 新增
    handleAdd(){
      this.isAdd = true
      this.Form = {
        examName:'',
        examTime:'',
        isEnable:1,
      }
      this.fileList = []
      this.$nextTick(() => {
        if (this.$refs['FormRef']) {
          this.$refs['FormRef'].clearValidate(); 
        }
      });
      this.FormVisible = true
    },

     // 编辑
    handleEdit(){
      this.isAdd = false
      if(!this.currentRow){
        this.$message({
          type:'error',
          message:'请选择要编辑的一行数据！'
        })
        return
      }
      this.Form = {
        examName:this.currentRow.ExamName,
        examTime:[this.currentRow.ExamBeginTime,this.currentRow.ExamEndTime],
        isEnable:this.currentRow.IsEnable?1:0,
      }
      this.$nextTick(() => {
        if (this.$refs['FormRef']) {
          this.$refs['FormRef'].clearValidate(); 
        }
      });
      this.FormVisible = true;
    },
    // 删除
    handleDel(){
      if(!this.currentRow){
        this.$message({
          message: '请选择要删除的一行数据',
          type: 'error'
        })
        return
      }
      this.$confirm('确定要删除该行数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        var params = {
          id :this.currentRow.Id
        }
        deleteExamProjectInfoQR(params).then(res => {
          if(res.data.Success){
            this.loading = false
            this.$message({
              type:'success',
              message:res.data.Message
            })
            this.getList()
          }else{
            this.loading = false
            this.$message({
              type:"error",
              message:res.data.Message
            })
          }            
        })         
      }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          }); 
        })
    },
    // 新增/编辑 提交表单
    FormSubmit(){
      this.$refs['FormRef'].validate((valid) => {
        if(valid){
          this.$confirm('确认提交吗？',"提示",{}).then(() => { 
            let params = {
                ExamName:this.Form.examName,
                ExamBeginTime:this.Form.examTime?this.Form.examTime[0]:"",
                ExamEndTime:this.Form.examTime?this.Form.examTime[1]:"",
                IsEnable:this.Form.isEnable
            }
            this.loading = true
            if(this.isAdd){
              addExamProjectInfoQR(params).then(res => {
                if(res.data.Success) {
                  this.loading = false;
                  this.$message({
                      message: '新增成功',
                      type: 'success'
                  });
                  this.FormVisible = false;
                  this.$refs['FormRef'].resetFields();
                  this.getList();
                }else{
                  this.loading = false;
                  this.$message({
                    message:'新增失败',
                    type:'error'
                  })
                }
              })
            }else{
            let params = {
              ExamName:this.Form.examName,
              ExamBeginTime:this.Form.examTime?this.Form.examTime[0]:"",
              ExamEndTime:this.Form.examTime?this.Form.examTime[1]:"",
              IsEnable:this.Form.isEnable,
              Id:this.currentRow.Id
            }
              updateExamProjectInfoQR(params).then(res => {
                if(res.data.Success) {
                  this.loading = false;
                  this.$message({
                      message: '更新成功',
                      type: 'success'
                  });
                  this.FormVisible = false;
                  this.$refs['FormRef'].resetFields();
                  this.getList();
                }else{
                  this.loading = false;
                  this.$message({
                    message:'新增失败',
                    type:'error'
                  })
                }
              })
            }
            
          })
        }
      })
    },
    handleSuccess(response,file,fileList){
      this.fileList = []
      this.fileList = [file]
      if(response.Success){
          this.$message.success(response.Message)
          this.Form.Type = file.raw.name.split('.').pop();
          this.Form.FileUrl = response.Response.weburl
          this.Form.FileName = response.Response.fileName
      }
    },
    customDelete(file){
        console.log("customDeletefile",file)
        this.fileList = this.fileList.filter(item => item.name !== file.name);
    },
    handlePreview(row) {
      // const qrContent = JSON.stringify({ examQRId: row.Id });
      // this.previewUrl = qrContent;

      this.previewUrl = `${window.location.origin}/exam?examQRId=${row.Id}`;
      this.previewDialogVisible = true;
    },
    async handleDownload(row){
      const url =`${window.location.origin}/exam?examQRId=${row.Id}`;
      //生成base64图片
      const imgBase64 = await QRCode2.toDataURL(url, { width: 350 })
      const a = document.createElement('a')
      a.href = imgBase64
      a.download = `考试二维码_${row.ExamName}.png`
      a.click()
    },
    closePreview() {
      this.previewUrl = '';
    },
    // 时间格式化
    formatCreateTime:function(row,column){
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    }, 
    callFunction(item) {
      this[item.Func].apply(this, item);
    },    
    getToken() {
      return localStorage.getItem("Token")
    }, 
    relatedPopulation(){
        if(!this.currentRow){
          this.$message.warning("请选择要关联的数据")
          return;
        }
          this.AddPopulationDialog = true
          let params = {

          }
          getSocialGroupList(params).then(res=>{
            console.log('res',res)
            if(res.data.Success){
                this.GroupListOption  = res.data.Response
            }
           
          })

    },
    openRelatedPopulationDialog(row){
      this.currentRow = row
      this.RelatedPopulationDialog = true
      this.getExamProjectInfoQRStaffListFun()
      
    },
    getExamProjectInfoQRStaffListFun(){
      let params = {
        id:this.currentRow.Id,
          pageIndex:this.pages2.pageIndex,
        pageSize:this.pages2.pageSize,
      }
       getExamProjectInfoQRStaffList(params).then(res=>{
        if(res.data.Success){
          console.log('res',res)
            this.tableData2 = res.data.Response.Data
            this.pages2.dataCount = res.data.Response.DataCount
            this.loading = false
        }
      })
    },
    AddPopulationSubmit(){
        this.$refs['FormRef2'].validate((valid) => {
          let params = {
            id:this.currentRow.Id,
          }
          if(this.Form2.relateMethods==0){
            params.socialGroupId = this.Form2.socialGroupId
          }
          if(this.Form2.relateMethods==1){
            params.phoneNumber = this.Form2.phoneNumber
          }
          addExamProjectInfoQRStaff(params).then(res=>{
              console.log('res',res)
              if(res.data.Success){
                this.$message.success(res.data.Message)
                this.AddPopulationDialog = false
                this.getList()
                this
              }else{
                   this.$message.warning(res.data.Message)
              }
          })
        })
    
    }
   
    
  },
  computed: {
    headers() {
      return{
        "Authorization": 'Bearer ' + this.getToken() // 直接从本地获取token就行
      }
    }
  },
  created(){
    this.getList()
  },
  mounted(){
    this.uploadObsDocumentFile = uploadObsDocumentFile;
    let routers = window.localStorage.router
    ? JSON.parse(window.localStorage.router)
    : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }

}
</script>

<style lang="stylus" scoped>
  .pageBarContainer{
    margin-top:20px;
		margin-bottom :20px
  }
  .special{
    display:flex!important;
    justify-content:center;
  }
  .checked .el-col p{
    display:inline-blocck!important;
    text-align:center!important;
  }
  .operation .el-col .el-button{
    display:block!important;
    margin:0 auto!important;
  }
  .judgeAnswer{
    vertical-align:middle!iportant;
    line-height:84px;
  }
  .answer{
    display:flex!important;
    align-items :center;
    height:45px;
  }
  /* 限制 iframe 容器的高度，防止撑破屏幕 */
.iframe-container {
  width: 100%;
  height: 70vh; /* 占据视口高度的 70% */
  background-color: #f0f2f5; /* 灰色背景，突出文档 */
}

iframe {
  display: block;
}
</style>